import React, { Component } from "react";
import { Link } from "react-router-dom";
export class Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false
    };
  }
  componentDidMount() {
    this.setState({ animation: true });
  }
  render() {
    return (
      <div
        className={
          this.state.animation ? "animate-in home-container" : "home-container"
        }
      >
        <div style={{ maxWidth: 1000 }} className="home-card">
          {/* <div className="home-card-title">
            <img
              style={{ width: "100%" }}
              src="https://www.sjcnc.org/wp-content/uploads/2016/08/IMG_7128-1.jpg"
              alt="" 
            />
            <h1 style={{ marginTop: "2rem" }}>Hello, I'm Heath Morber!</h1>
          </div> */}
          <div className="home-card-body">
            <div className="about-heading">
              <h1>Recordings</h1>
              <a
                target="_blank"
                rel="noopener noreferer"
                href="https://www.dropbox.com/sh/jw0adgvsrswem4u/AAAWUcJb52UgpB33763uh-Nia?dl=0"
              >
                English Motet recordings (dropdox)
              </a>
            </div>
          </div>

          <div className="sample-vids">
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/aRD6POiB8C8"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/Ba-zXzngbn8"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/_WlU29W0g0s"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/aBSfXc4Auno"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/Di63LJNTE6s"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/gtWtuytABFg"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/NVf4h2ncRiw"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/_fD4YiKf6kI"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/NQjAidkyK5A"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/4moL9r37Rb8"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            {/* Dvidider? */}
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/v-6pByBMExg"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/WrEV7JV_pOs"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/zL0RnZG_Mps"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/esN07GG2n3U"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/KNc6IpVFBfY"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/40q0v4VDQNI"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/eTKG7Rcao04"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/yfcFrkmyAvM"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <iframe
              width="250"
              height="250"
              src="https://www.youtube.com/embed/8QBkxDxa2Xc"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default Videos;



// WEBPACK FOOTER //
// ./src/components/Videos.js